<div class="pwa-stack">
  @if (!online()) {
    <nz-alert
      nzType="error"
      nzShowIcon
      [nzMessage]="'pwa.offlineTitle' | translate"
      [nzDescription]="'pwa.offlineDetail' | translate"
    ></nz-alert>
  }

  @if (pwaUpdate.updateAvailable()) {
    <nz-alert
      nzType="info"
      nzShowIcon
      [nzMessage]="'pwa.updateTitle' | translate"
      [nzAction]="updateAction"
    ></nz-alert>
    <ng-template #updateAction>
      <button
        nz-button
        nzType="primary"
        nzSize="small"
        [disabled]="pwaUpdate.applying()"
        (click)="applyUpdate()"
        id="pwa-update-button"
      >
        {{ (pwaUpdate.applying() ? 'pwa.updating' : 'pwa.updateAction') | translate }}
      </button>
    </ng-template>
  }

  @if (pwaInstall.showIosHint()) {
    <nz-alert
      nzType="info"
      nzShowIcon
      nzCloseable
      [nzMessage]="'pwa.installHintTitle' | translate"
      [nzDescription]="'pwa.installHintIos' | translate"
      (nzOnClose)="dismissIosHint()"
    ></nz-alert>
  }
</div>
